// extracted by mini-css-extract-plugin
export var box = "_4v-0";
export var check = "_4v-1";
export var checkboxButton = "_4v-6";
export var checkboxGroup = "_4v-5";
export var disabled = "_4v-7";
export var ghost = "_4v-9";
export var input = "_4v-2";
export var label = "_4v-4";
export var normal = "_4v-8";
export var uncheck = "_4v-3";